import React, { useState, useEffect } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { initializeApp } from 'firebase/app';
import { getAuth, OAuthProvider, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc, setDoc, collection, onSnapshot } from 'firebase/firestore';


// --- Firebase Configuration ---
// Your project's configuration has been added here.
const firebaseConfig = {
    apiKey: "AIzaSyAKhbpjconJrQSgTr9KQbko9Qhvk_skB5s",
    authDomain: "tamira---workbook.firebaseapp.com",
    projectId: "tamira---workbook",
    storageBucket: "tamira---workbook.firebasestorage.app",
    messagingSenderId: "555251228635",
    appId: "1:555251228635:web:8fb130be4b1493974851fe",
    measurementId: "G-QZXQ2XF2KS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);


// --- Helper Functions ---
const getStartOfWeek = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    const day = d.getDay();
    const diff = d.getDate() - day;
    return new Date(d.setDate(diff));
};

const toYYYYMMDD = (date) => {
    if (!date) return '';
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
};

const generateTimeOptions = (startHour = 0, startMinute = -1) => {
    const options = [];
    for (let i = startHour; i < 24; i++) {
        for (let j = 0; j < 60; j += 30) {
            if (i === startHour && j <= startMinute) continue;
            const hour = i.toString().padStart(2, '0');
            const minute = j.toString().padStart(2, '0');
            options.push(`${hour}:${minute}`);
        }
    }
    return options;
};


// --- Animation Configurations ---
const animationTypes = ['confetti-fall', 'confetti-burst', 'confetti-rain', 'confetti-launch'];
const animations = Array.from({ length: 50 }, (_, i) => ({
    type: animationTypes[i % animationTypes.length],
    colors: [['#f44336', '#e91e63', '#9c27b0'], ['#2196f3', '#03a9f4', '#00bcd4'], ['#4caf50', '#8bc34a', '#cddc39']][i % 3],
    particleCount: 50 + (i * 2),
}));


// --- UI Components ---

const SubmissionAnimation = ({ type, colors, particleCount }) => {
    const particleArray = Array.from({ length: particleCount });
    switch (type) {
        case 'confetti-burst': return <div className="animation-container">{particleArray.map((_, i) => <div key={i} className="confetti-burst-particle" style={{ '--color': colors[i % 3], '--i': i }}></div>)}</div>;
        case 'confetti-rain': return <div className="animation-container">{particleArray.map((_, i) => <div key={i} className="confetti-rain-particle" style={{ '--color': colors[i % 3], '--x': `${Math.random() * 100}%`, '--delay': `${Math.random() * 1.5}s` }}></div>)}</div>;
        case 'confetti-launch': return <div className="animation-container">{particleArray.map((_, i) => <div key={i} className="confetti-launch-particle" style={{ '--color': colors[i % 3], '--x': `${10 + Math.random() * 80}%`, '--delay': `${Math.random() * 0.5}s` }}></div>)}</div>;
        case 'confetti-fall': default: return <div className="animation-container">{particleArray.map((_, i) => <div key={i} className="confetti-fall-particle" style={{ '--color': colors[Math.floor(Math.random() * colors.length)], '--x': `${Math.random() * 100}vw`, '--y': `${Math.random() * 100}vh`, '--duration': `${0.8 + Math.random() * 1.2}s`, '--delay': `${Math.random() * 0.5}s`, }} />)}</div>;
    }
};

const FrazzledTiger = () => (
    <div className="p-8 rounded-lg shadow-sm bg-white dark:bg-gray-800 text-center flex flex-col items-center justify-center">
        <svg className="w-32 h-32" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <g>
                <g className="motion-lines" style={{ animation: 'dash 0.5s linear infinite' }}><path d="M 10,120 L 30,120" stroke="#9CA3AF" strokeWidth="3" strokeDasharray="5,5" /><path d="M 5,140 L 25,140" stroke="#9CA3AF" strokeWidth="3" strokeDasharray="5,5" /></g>
                <path d="M 170,110 C 190,90 190,50 170,30" stroke="#F97316" strokeWidth="12" fill="none" strokeLinecap="round" /><path d="M 170,100 C 180,90 180,75 170,65" stroke="black" strokeWidth="4" fill="none" /><path d="M 170,80 C 175,75 175,65 170,60" stroke="black" strokeWidth="4" fill="none" />
                <path d="M 130,140 C 140,120 150,130 160,150" fill="#F97316" stroke="#A16207" strokeWidth="2" /><path d="M 140,145 L 130,130" stroke="black" strokeWidth="3" strokeLinecap="round" />
                <path d="M 60,150 C 60,100 140,100 140,150 Z" fill="#F97316" stroke="#A16207" strokeWidth="2" />
                <path d="M 70,140 C 60,120 50,130 40,150" fill="#F97316" stroke="#A16207" strokeWidth="2" /><path d="M 60,145 L 70,130" stroke="black" strokeWidth="3" strokeLinecap="round" />
                <path d="M 50,100 C 40,60 110,60 100,100 C 100,100 80,115 50,100 Z" fill="#F97316" stroke="#A16207" strokeWidth="2" />
                <path d="M 45,65 A 15,15 0 0,1 65,55" fill="#F97316" stroke="#A16207" strokeWidth="2" /><path d="M 95,65 A 15,15 0 0,0 75,55" fill="#F97316" stroke="#A16207" strokeWidth="2" />
                <path d="M 60,95 C 60,105 90,105 90,95 C 90,85 60,85 60,95 Z" fill="white" />
                <circle cx="65" cy="80" r="7" fill="white" /><circle cx="85" cy="80" r="7" fill="white" /><circle cx="67" cy="82" r="3" fill="black" /><circle cx="83" cy="82" r="3" fill="black" />
                <polygon points="73,92 77,92 75,96" fill="black" />
                <path d="M 55,70 L 48,85" stroke="black" strokeWidth="3" strokeLinecap="round" /><path d="M 95,70 L 102,85" stroke="black" strokeWidth="3" strokeLinecap="round" /><path d="M 80,110 L 85,130" stroke="black" strokeWidth="4" strokeLinecap="round" /><path d="M 110,110 L 115,130" stroke="black" strokeWidth="4" strokeLinecap="round" /><path d="M 130,115 L 135,135" stroke="black" strokeWidth="4" strokeLinecap="round" />
            </g>
            <style>{` @keyframes dash { to { stroke-dashoffset: -10; } } `}</style>
        </svg>
        <p className="mt-4 text-lg font-semibold text-gray-700 dark:text-gray-300">Woahhhh... easy there tiger! or tigress...</p>
    </div>
);

const KickoffDayCard = ({ dayDate, log, handleInputChange, handleSubmit, handleModuleSelect, liveDate }) => {
    const dayString = toYYYYMMDD(dayDate);
    const isSubmitted = log.submitted;
    const timeDiff = dayDate.getTime() - liveDate.getTime();
    const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    const isLockedPast = dayDiff < -1 && !isSubmitted;
    const isLockedFuture = dayDiff > 3 && !isSubmitted;

    if (isLockedFuture) return <FrazzledTiger />;

    const startHour = log.start ? parseInt(log.start.split(':')[0], 10) : 0;
    const startMinute = log.start ? parseInt(log.start.split(':')[1], 10) : -1;
    const endOptions = generateTimeOptions(startHour, startMinute);

    let plannedHours = 'N/A';
    if (log.start && log.end) {
        const startTime = new Date(`1970-01-01T${log.start}:00`);
        const endTime = new Date(`1970-01-01T${log.end}:00`);
        let diff = (endTime - startTime) / (1000 * 60 * 60);
        if (diff < 0) diff = 0;
        plannedHours = (diff - (parseFloat(log.break) || 0)).toFixed(2);
    }

    return (
        <div>
            <div className={`p-4 rounded-lg shadow-sm ${isSubmitted || isLockedPast ? 'bg-gray-200 dark:bg-gray-700' : 'bg-white dark:bg-gray-800'}`}>
                <h3 className="font-bold text-gray-800 dark:text-gray-200">{dayDate.toLocaleDateString('en-US', { weekday: 'long' })} <span className="font-normal text-gray-500 dark:text-gray-400">({dayDate.toLocaleDateString()})</span></h3>
                <div className="mt-3 grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                    <div><label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Start</label><select value={log.start || ''} onChange={(e) => handleInputChange(dayString, 'start', e.target.value, 'kickoff')} disabled={isSubmitted || isLockedPast} className="w-full mt-1 p-2 border rounded-md disabled:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:disabled:bg-gray-600"><option value="">Select</option>{generateTimeOptions().map(t => <option key={t} value={t}>{t}</option>)}</select></div>
                    <div><label className="block text-sm font-medium text-gray-700 dark:text-gray-300">End</label><select value={log.end || ''} onChange={(e) => handleInputChange(dayString, 'end', e.target.value, 'kickoff')} disabled={isSubmitted || isLockedPast || !log.start} className="w-full mt-1 p-2 border rounded-md disabled:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:disabled:bg-gray-600"><option value="">Select</option>{endOptions.map(t => <option key={t} value={t}>{t}</option>)}</select></div>
                    <div><label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Break (h)</label><input type="number" placeholder="e.g. 1.5" value={log.break || ''} onChange={(e) => handleInputChange(dayString, 'break', e.target.value, 'kickoff')} disabled={isSubmitted || isLockedPast} className="w-full mt-1 p-2 border rounded-md disabled:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:disabled:bg-gray-600" /></div>
                    <div><label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Planned Hours</label><div className="w-full mt-1 p-2 border rounded-md bg-gray-100 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600">{plannedHours !== 'N/A' ? `${plannedHours} h` : 'N/A'}</div></div>
                </div>
                <div className="mt-4">{isSubmitted ? <p className="text-sm font-semibold text-green-500">Submitted and Locked</p> : isLockedPast ? <p className="text-sm font-semibold text-red-500">Entry locked (past date)</p> : <button onClick={() => handleSubmit(dayString, 'kickoff')} className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600">Submit</button>}</div>
            </div>
            <div className="mt-2 text-right"><button onClick={() => handleModuleSelect('wrap')} className="px-4 py-2 bg-gray-200 dark:bg-gray-700 dark:text-gray-200 text-gray-700 rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 text-sm">View 5 minute Wrap &rarr;</button></div>
        </div>
    );
};

const WrapDayCard = ({ dayDate, kickoffLog, wrapLog, handleInputChange, handleSubmit, handleModuleSelect, liveDate }) => {
    const dayString = toYYYYMMDD(dayDate);
    const isSubmitted = wrapLog.submitted;
    const timeDiff = dayDate.getTime() - liveDate.getTime();
    const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    const isLocked = (dayDiff < -1 || dayDiff > 1) && !isSubmitted;
    const workCubes = Math.round((parseFloat(wrapLog.hours) || 0) / 2) || 1;
    let plannedHours = 'N/A';
    if (kickoffLog && kickoffLog.start && kickoffLog.end) {
        const startTime = new Date(`1970-01-01T${kickoffLog.start}:00`);
        const endTime = new Date(`1970-01-01T${kickoffLog.end}:00`);
        let diff = (endTime - startTime) / (1000 * 60 * 60);
        if (diff < 0) diff = 0;
        plannedHours = (diff - (parseFloat(kickoffLog.break) || 0)).toFixed(2);
    }
    const isSubmittable = () => {
        if (!wrapLog.workDone || wrapLog.workDone.length < workCubes) return false;
        for (let i = 0; i < workCubes; i++) {
            if (!wrapLog.workDone[i] || wrapLog.workDone[i].trim() === '') return false;
        }
        return true;
    };
    if (!kickoffLog.submitted && !isSubmitted) {
        return (<div className="p-4 rounded-lg shadow-sm bg-yellow-50 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-300"><h3 className="font-bold text-gray-800 dark:text-gray-200">{dayDate.toLocaleDateString('en-US', { weekday: 'long' })} <span className="font-normal text-gray-500 dark:text-gray-400">({dayDate.toLocaleDateString()})</span></h3><p className="mt-2">Please complete and submit "Daily - 5 minute Kickoff" for this day to activate the workbook.</p></div>);
    }
    return (
        <div>
            <div className={`p-4 rounded-lg shadow-sm ${isSubmitted || isLocked ? 'bg-gray-200 dark:bg-gray-700' : 'bg-white dark:bg-gray-800'}`}>
                <h3 className="font-bold text-gray-800 dark:text-gray-200">{dayDate.toLocaleDateString('en-US', { weekday: 'long' })} <span className="font-normal text-gray-500 dark:text-gray-400">({dayDate.toLocaleDateString()})</span></h3>
                <div className="mt-3 space-y-4">
                    <div className="grid grid-cols-2 gap-4">
                        <div><label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Planned Hours</label><div className="w-full mt-1 p-2 border rounded-md bg-gray-100 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600">{plannedHours !== 'N/A' ? `${plannedHours} h` : 'N/A'}</div></div>
                        <div><label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Actual Hours</label><div className="flex items-center mt-1"><input type="text" placeholder="Hours" value={wrapLog.hours || ''} onChange={(e) => handleInputChange(dayString, 'hours', e.target.value, 'wrap')} disabled={isSubmitted || isLocked} className="w-full p-2 border rounded-md disabled:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:disabled:bg-gray-600" /><span className="ml-2 text-gray-500 dark:text-gray-400">h</span></div></div>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Work Cubes ({workCubes} {workCubes > 1 ? 'entries' : 'entry'})</label>
                        <div className="space-y-2 mt-1">{Array.from({ length: workCubes }).map((_, i) => (<div key={i} className="flex items-center gap-2"><span className="font-semibold text-gray-500 dark:text-gray-400">{i + 1}.</span><input type="text" placeholder={`Cube ${i + 1}`} value={(wrapLog.workDone && wrapLog.workDone[i]) || ''} onChange={(e) => handleInputChange(dayString, 'workDone', e.target.value, 'wrap', i)} disabled={isSubmitted || isLocked} className="w-full p-2 border rounded-md disabled:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:disabled:bg-gray-600" /></div>))}</div>
                    </div>
                </div>
                <div className="mt-4">{isSubmitted ? <p className="text-sm font-semibold text-green-500">Submitted and Locked</p> : isLocked ? <p className="text-sm font-semibold text-red-500">Entry locked (date out of range)</p> : <button onClick={() => handleSubmit(dayString, 'wrap')} disabled={!isSubmittable()} className={`px-4 py-2 text-white rounded-md ${isSubmittable() ? 'bg-purple-500 hover:bg-purple-600' : 'bg-gray-400 cursor-not-allowed'}`}>Submit</button>}</div>
            </div>
            <div className="mt-2 text-right"><button onClick={() => handleModuleSelect('kickoff')} className="px-4 py-2 bg-gray-200 dark:bg-gray-700 dark:text-gray-200 text-gray-700 rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 text-sm">&larr; View 5 minute Kickoff</button></div>
        </div>
    );
};

const DayCard = ({ dayDate, module, kickoffLogs, wrapLogs, handleInputChange, handleSubmit, handleModuleSelect, liveDate }) => {
    const dayString = toYYYYMMDD(dayDate);
    if (module === 'kickoff') return <KickoffDayCard dayDate={dayDate} log={kickoffLogs[dayString] || {}} handleInputChange={handleInputChange} handleSubmit={handleSubmit} handleModuleSelect={handleModuleSelect} liveDate={liveDate} />;
    if (module === 'wrap') return <WrapDayCard dayDate={dayDate} kickoffLog={kickoffLogs[dayString] || {}} wrapLog={wrapLogs[dayString] || {}} handleInputChange={handleInputChange} handleSubmit={handleSubmit} handleModuleSelect={handleModuleSelect} liveDate={liveDate} />;
    return null;
};

const PerformanceTracker = ({ teamLogs, expectedWeeklyHours }) => {
    if (!expectedWeeklyHours) return <p className="text-sm text-gray-500 dark:text-gray-400">Set expected weekly hours to see performance.</p>;

    const wrapLogEntries = Object.values(teamLogs.wrap);
    const totalActualHours = wrapLogEntries.reduce((sum, log) => sum + (parseFloat(log.hours) || 0), 0);
    const numberOfEntries = wrapLogEntries.filter(log => log.submitted).length;

    const expectedDailyHours = parseFloat(expectedWeeklyHours) / 5;
    const expectedHoursForEntries = expectedDailyHours * numberOfEntries;

    let performancePercentage = 0;
    if (expectedHoursForEntries > 0) {
        performancePercentage = Math.round((totalActualHours / expectedHoursForEntries) * 100);
    }

    const barColor = performancePercentage < 70 ? 'bg-red-500' : performancePercentage < 90 ? 'bg-yellow-500' : 'bg-green-500';
    const displayPercentage = Math.min(performancePercentage, 100);

    return (
        <div>
            <h4 className="font-semibold text-gray-700 dark:text-gray-300">Weekly Performance</h4>
            <div className="flex items-center gap-4 mt-1">
                <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-4">
                    <div className={`${barColor} h-4 rounded-full`} style={{ width: `${displayPercentage}%` }}></div>
                </div>
                <span className="font-bold text-lg dark:text-gray-200">{performancePercentage}%</span>
            </div>
        </div>
    );
};

const AdminView = ({
    teamMembers, selectedTeamMember, setSelectedTeamMember,
    expectedHours, setExpectedHours, isHoursDirty, setIsHoursDirty,
    handleSaveExpectedHours, teamLogs, exportStartDate, setExportStartDate,
    exportEndDate, setExportEndDate, handleExport
}) => {
    const combinedLogs = {};
    const kickoffDays = Object.keys(teamLogs.kickoff);
    const wrapDays = Object.keys(teamLogs.wrap);
    const allDays = [...new Set([...kickoffDays, ...wrapDays])];
    allDays.forEach(day => { combinedLogs[day] = { kickoff: teamLogs.kickoff[day] || {}, wrap: teamLogs.wrap[day] || {} }; });
    const logsToShow = Object.entries(combinedLogs).sort(([dayA], [dayB]) => new Date(dayA) - new Date(dayB));

    return (
        <div>
            <div className="mb-6 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                    <label htmlFor="team-member-select" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Select Team Member</label>
                    <select id="team-member-select" value={selectedTeamMember || ''} onChange={(e) => setSelectedTeamMember(e.target.value)} className="mt-1 block w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700 dark:text-gray-200">
                        <option value="">-- View Logs For --</option>
                        {teamMembers.map(member => <option key={member.id} value={member.id}>{member.name}</option>)}
                    </select>
                </div>
                {selectedTeamMember && (
                    <>
                        <div>
                            <label htmlFor="expected-hours" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Expected Weekly Hours</label>
                            <div className="mt-1 flex gap-2">
                                <input id="expected-hours" type="number" value={expectedHours} onChange={(e) => { setExpectedHours(e.target.value); setIsHoursDirty(true); }} className="block w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700 dark:text-gray-200" />
                                <button onClick={handleSaveExpectedHours} disabled={!isHoursDirty} className={`px-4 py-2 text-white rounded-md ${isHoursDirty ? 'bg-blue-500 hover:bg-blue-600' : 'bg-gray-400 cursor-not-allowed dark:bg-gray-500'}`}>Set</button>
                            </div>
                        </div>
                        <PerformanceTracker teamLogs={teamLogs} expectedWeeklyHours={expectedHours} />
                    </>
                )}
            </div>

            {selectedTeamMember && (
                <>
                    <div className="my-8 p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
                        <h3 className="text-lg font-semibold mb-2 dark:text-gray-200">Export Logs</h3>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                            <div><label htmlFor="start-date" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Start Date</label><input id="start-date" type="date" value={exportStartDate} onChange={e => setExportStartDate(e.target.value)} className="mt-1 block w-full p-2 border rounded-md dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600" /></div>
                            <div><label htmlFor="end-date" className="block text-sm font-medium text-gray-700 dark:text-gray-300">End Date</label><input id="end-date" type="date" value={exportEndDate} onChange={e => setExportEndDate(e.target.value)} className="mt-1 block w-full p-2 border rounded-md dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600" /></div>
                            <button onClick={handleExport} className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700">Export as CSV</button>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-xl font-semibold mb-2 dark:text-gray-200">Combined Daily Logs for <span className="text-blue-600 dark:text-blue-400">{teamMembers.find(m => m.id === selectedTeamMember)?.name}</span></h3>
                        <div className="space-y-4">
                            {logsToShow.length > 0 ? logsToShow.map(([day, logs]) => {
                                const kickoffLog = logs.kickoff;
                                const wrapLog = logs.wrap;
                                let plannedHours = 'N/A';
                                if (kickoffLog.start && kickoffLog.end) {
                                    const startTime = new Date(`1970-01-01T${kickoffLog.start}:00`);
                                    const endTime = new Date(`1970-01-01T${kickoffLog.end}:00`);
                                    let diff = (endTime - startTime) / (1000 * 60 * 60);
                                    if (diff < 0) diff = 0;
                                    plannedHours = (diff - (parseFloat(kickoffLog.break) || 0)).toFixed(2);
                                }
                                return (
                                    <div key={day} className="p-4 bg-gray-100 dark:bg-gray-800 rounded-lg border dark:border-gray-700">
                                        <p className="font-bold text-lg dark:text-gray-200">{new Date(day + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</p>
                                        <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-x-6">
                                            <div className="border-r-0 md:border-r md:pr-6 border-gray-300 dark:border-gray-700">
                                                <h4 className="font-semibold text-blue-600 dark:text-blue-400 mb-2">Kickoff Details</h4>
                                                <p className="dark:text-gray-300"><strong>Time:</strong> {kickoffLog.start || 'N/A'} - {kickoffLog.end || 'N/A'}</p>
                                                <p className="dark:text-gray-300"><strong>Break:</strong> {kickoffLog.break || 0} h</p>
                                                <p className="dark:text-gray-300"><strong>Planned Hours:</strong> {plannedHours} h</p>
                                                {kickoffLog.submittedAt && <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">Submitted: {new Date(kickoffLog.submittedAt).toLocaleString()}</p>}
                                            </div>
                                            <div className="mt-4 md:mt-0">
                                                <h4 className="font-semibold text-purple-600 dark:text-purple-400 mb-2">Wrap Details</h4>
                                                <p className="dark:text-gray-300"><strong>Actual Hours:</strong> {wrapLog.hours || 'N/A'} h</p>
                                                <div className="dark:text-gray-300"><strong>Work Cubes:</strong>{Array.isArray(wrapLog.workDone) && wrapLog.workDone.length > 0 && wrapLog.workDone.some(t => t) ? (<ul className="list-disc list-inside ml-4">{wrapLog.workDone.map((task, i) => task && <li key={i}>{task}</li>)}</ul>) : <p className="inline ml-2">N/A</p>}</div>
                                                {wrapLog.submittedAt && <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">Submitted: {new Date(wrapLog.submittedAt).toLocaleString()}</p>}
                                            </div>
                                        </div>
                                    </div>
                                );
                            }) : <p className="text-center text-gray-500 dark:text-gray-400 mt-8">No logs found for this user for this week.</p>}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

const LoginScreen = ({ handleLogin, handleMicrosoftLogin, theme, setTheme }) => (
    <div className="text-center">
        <ThemeToggle theme={theme} setTheme={setTheme} />
        <h2 className="text-2xl font-bold mb-4 dark:text-gray-200">Login</h2>
        <p className="mb-4 text-gray-600 dark:text-gray-400">Please sign in to continue.</p>
        {/* <button onClick={handleLogin} className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center mx-auto gap-2">
            <svg className="w-6 h-6" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571l6.19,5.238C39.901,36.636,44,30.833,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path></svg>
            Sign in with Google
        </button><br></br> */}
        <button onClick={handleMicrosoftLogin} className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center mx-auto gap-2">
            <svg className="w-6 h-6" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <rect x="0" y="0" width="24" height="24" fill="#F25022" />
                <rect x="24" y="0" width="24" height="24" fill="#7FBA00" />
                <rect x="0" y="24" width="24" height="24" fill="#00A4EF" />
                <rect x="24" y="24" width="24" height="24" fill="#FFB900" />
            </svg>
            Sign in with Microsoft
        </button>
    </div>
);

const ModuleSelectionScreen = ({ handleModuleSelect }) => (
    <div className="text-center">
        <h2 className="text-2xl font-bold mb-4 dark:text-gray-200">Select a Module</h2>
        <div className="flex justify-center gap-4">
            <button onClick={() => handleModuleSelect('kickoff')} className="px-8 py-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600 text-xl">Daily - 5 minute Kickoff</button>
            <button onClick={() => handleModuleSelect('wrap')} className="px-8 py-4 bg-purple-500 text-white rounded-lg hover:bg-purple-600 text-xl">Daily - 5 minute Wrap</button>
        </div>
    </div>
);

const UserModuleHeader = ({ currentModule, viewMode, setViewMode, currentDate, navigateDate, theme, setTheme }) => {
    const title = currentModule === 'kickoff' ? "Daily - 5 minute Kickoff" : "Daily - 5 minute Wrap";
    const viewTitle = viewMode === 'daily' ? `Date: ${currentDate.toLocaleDateString()}` : `Week of: ${getStartOfWeek(currentDate).toLocaleDateString()}`;
    return (<div className="mb-6"><div className="flex justify-between items-center"><h2 className="text-2xl font-semibold dark:text-gray-200">{title}</h2><div className="flex items-center gap-4"><div className="flex items-center gap-2 p-1 bg-gray-200 dark:bg-gray-700 rounded-lg"><button onClick={() => setViewMode('daily')} className={`px-3 py-1 rounded-md text-sm ${viewMode === 'daily' ? 'bg-white dark:bg-gray-900 dark:text-gray-200 shadow' : 'dark:text-gray-400'}`}>Daily</button><button onClick={() => setViewMode('weekly')} className={`px-3 py-1 rounded-md text-sm ${viewMode === 'weekly' ? 'bg-white dark:bg-gray-900 dark:text-gray-200 shadow' : 'dark:text-gray-400'}`}>Weekly</button></div><ThemeToggle theme={theme} setTheme={setTheme} /></div></div><div className="flex justify-between items-center mt-4"><button onClick={() => navigateDate(-1)} className="px-4 py-2 bg-white dark:bg-gray-800 dark:text-gray-200 border dark:border-gray-700 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 shadow-sm">&larr; Previous</button><p className="text-center font-semibold dark:text-gray-200">{viewTitle}</p><button onClick={() => navigateDate(1)} className="px-4 py-2 bg-white dark:bg-gray-800 dark:text-gray-200 border dark:border-gray-700 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 shadow-sm">Next &rarr;</button></div></div>);
};

const AdminModuleHeader = ({ adminWeekStart, setAdminWeekStart, theme, setTheme }) => {
    const navigateAdminWeek = (direction) => { const newWeek = new Date(adminWeekStart); newWeek.setDate(newWeek.getDate() + (direction * 7)); setAdminWeekStart(newWeek); };
    return (<div className="mb-6"><div className="flex justify-between items-center"><h2 className="text-2xl font-semibold dark:text-gray-200">Admin Dashboard</h2><ThemeToggle theme={theme} setTheme={setTheme} /></div><div className="flex justify-between items-center mt-4"><button onClick={() => navigateAdminWeek(-1)} className="px-4 py-2 bg-white dark:bg-gray-800 dark:text-gray-200 border dark:border-gray-700 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 shadow-sm">&larr; Previous Week</button><p className="text-center font-semibold dark:text-gray-200">Week of: {adminWeekStart.toLocaleDateString()}</p><button onClick={() => navigateAdminWeek(1)} className="px-4 py-2 bg-white dark:bg-gray-800 dark:text-gray-200 border dark:border-gray-700 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 shadow-sm">Next Week &rarr;</button></div></div>);
};

const UserModuleView = ({ viewMode, currentDate, currentModule, kickoffLogs, wrapLogs, handleInputChange, handleSubmit, handleModuleSelect, liveDate }) => {
    const daysToRender = [];
    const weekStart = getStartOfWeek(currentDate);
    if (viewMode === 'weekly') { for (let i = 0; i < 7; i++) { const day = new Date(weekStart); day.setDate(day.getDate() + i); daysToRender.push(day); } } else { daysToRender.push(currentDate); }
    return <div className="space-y-4">{daysToRender.map(d => <DayCard key={d.toISOString()} dayDate={d} module={currentModule} kickoffLogs={kickoffLogs} wrapLogs={wrapLogs} handleInputChange={handleInputChange} handleSubmit={handleSubmit} handleModuleSelect={handleModuleSelect} liveDate={liveDate} />)}</div>;
};

const ThemeToggle = ({ theme, setTheme }) => (
    <div className="flex items-center">
        <span className="mr-2 text-sm font-medium text-gray-900 dark:text-gray-300">Dark Mode</span>
        <label className="relative inline-flex items-center cursor-pointer">
            <input type="checkbox" checked={theme === 'dark'} onChange={() => setTheme(theme === 'light' ? 'dark' : 'light')} className="sr-only peer" />
            <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
        </label>
    </div>
);


// --- Main Application Component ---
const App = () => {
    // --- State Management ---
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
    const [currentUser, setCurrentUser] = useState(null);
    const [currentModule, setCurrentModule] = useState(null);
    const [viewMode, setViewMode] = useState('daily');
    const [currentDate, setCurrentDate] = useState(() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; });
    const [liveDate] = useState(() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; });

    const [kickoffLogs, setKickoffLogs] = useState({});
    const [wrapLogs, setWrapLogs] = useState({});

    const [isAdmin, setIsAdmin] = useState(false);
    const [adminWeekStart, setAdminWeekStart] = useState(() => getStartOfWeek(new Date()));
    const [teamLogs, setTeamLogs] = useState({ kickoff: {}, wrap: {} });
    const [selectedTeamMember, setSelectedTeamMember] = useState(null);
    const [teamMembers, setTeamMembers] = useState([]);
    const [expectedHours, setExpectedHours] = useState('');
    const [isHoursDirty, setIsHoursDirty] = useState(false);
    const [exportStartDate, setExportStartDate] = useState('');
    const [exportEndDate, setExportEndDate] = useState('');
    const [submissionCounter, setSubmissionCounter] = useState(0);

    useEffect(() => {
        if (theme === 'dark') {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
        localStorage.setItem('theme', theme);
    }, [theme]);

    // --- Authentication and User Data ---
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                // IMPORTANT: Add your admin emails to this list
                const adminEmails = ['gaurav@tamiratech.com', 'prafullit.sharma@tamiratech.com', 'vaishali@alfredx.com', 'prafullit@alfredx.com', 'gaurav@alfredx.com'];
                setIsAdmin(adminEmails.includes(user.email));
                setCurrentUser(user);

                // Save user info to a 'users' collection for the admin to see
                const userRef = doc(db, "users", user.uid);
                await setDoc(userRef, { name: user.displayName, email: user.email }, { merge: true });

            } else {
                setCurrentUser(null);
                setIsAdmin(false);
            }
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (isAdmin) {
            const unsub = onSnapshot(collection(db, "users"), (snapshot) => {
                const members = snapshot.docs
                    .map(doc => ({ id: doc.id, ...doc.data() }))
                    .filter(u => u.email !== auth.currentUser.email);
                setTeamMembers(members);
            });
            return () => unsub();
        }
    }, [isAdmin]);

    // --- Data Fetching for Logs ---
    useEffect(() => {
        if (!currentUser) return;

        let userIdToFetch = isAdmin ? selectedTeamMember : currentUser.uid;
        let weekToFetch = isAdmin ? adminWeekStart : getStartOfWeek(currentDate);

        if (!userIdToFetch) {
            setTeamLogs({ kickoff: {}, wrap: {} });
            return;
        }

        const weekId = toYYYYMMDD(weekToFetch);
        const docRef = doc(db, "workbooks", userIdToFetch, "weeks", weekId);

        const unsub = onSnapshot(docRef, (docSnap) => {
            const data = docSnap.data() || {};
            if (isAdmin) {
                setTeamLogs({ kickoff: data.kickoffLogs || {}, wrap: data.wrapLogs || {} });
            } else {
                setKickoffLogs(data.kickoffLogs || {});
                setWrapLogs(data.wrapLogs || {});
            }
        });

        return () => unsub();

    }, [currentUser, currentDate, selectedTeamMember, isAdmin, adminWeekStart]);

    // --- Admin: Fetch Expected Hours ---
    useEffect(() => {
        if (isAdmin && selectedTeamMember) {
            const userRef = doc(db, "users", selectedTeamMember);
            getDoc(userRef).then(docSnap => {
                if (docSnap.exists()) {
                    const savedHours = docSnap.data().expectedWeeklyHours || '';
                    setExpectedHours(savedHours);
                    setIsHoursDirty(!savedHours);
                }
            });
        } else {
            setExpectedHours('');
            setIsHoursDirty(false);
        }
    }, [isAdmin, selectedTeamMember]);

    // --- Event Handlers ---
    const handleMicrosoftLogin = async () => {
        // Create a new instance of the Microsoft OAuth provider
        const provider = new OAuthProvider('microsoft.com');

        // Add custom parameters if needed
        provider.setCustomParameters({
            tenant: 'f642ac30-c1c6-4020-bab9-f4b63926bafb'
        });

        try {
            await signInWithPopup(auth, provider);
            console.log("Successfully logged in with Microsoft!");
        } catch (error) {
            console.error("Authentication error:", error);
        }
    };
    const handleLogin = async () => {
        const provider = new GoogleAuthProvider();
        try {
            await signInWithPopup(auth, provider);
        } catch (error) {
            console.error("Authentication error:", error);
        }
    };

    const handleLogout = () => signOut(auth);
    const handleModuleSelect = (module) => setCurrentModule(module);

    const handleInputChange = (day, field, value, module, index = -1) => {
        const logUpdater = module === 'kickoff' ? setKickoffLogs : setWrapLogs;

        if (module === 'wrap' && field === 'hours') {
            if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
                logUpdater(prev => ({ ...prev, [day]: { ...(prev[day] || {}), [field]: value } }));
            }
            return;
        }

        logUpdater(prev => {
            const dayLog = { ...(prev[day] || {}) };
            if (module === 'wrap' && field === 'workDone') {
                const workDoneArray = Array.isArray(dayLog.workDone) ? [...dayLog.workDone] : [];
                workDoneArray[index] = value;
                dayLog.workDone = workDoneArray;
            } else { dayLog[field] = value; }
            return { ...prev, [day]: dayLog };
        });
    };

    const handleSubmit = async (day, module) => {
        if (!currentUser) return;

        const logs = module === 'kickoff' ? kickoffLogs : wrapLogs;
        const dayLog = logs[day] || {};

        if (module === 'wrap') {
            const workCubes = Math.round((parseFloat(dayLog.hours) || 0) / 2) || 1;
            const workDoneEntries = dayLog.workDone || [];
            for (let i = 0; i < workCubes; i++) {
                if (!workDoneEntries[i] || workDoneEntries[i].trim() === '') {
                    alert(`Please fill in all ${workCubes} Work Cubes before submitting.`);
                    return;
                }
            }
        }

        let triggerAnimation = false;
        if (Math.random() < 0.25) {
            triggerAnimation = true;
        } else if (submissionCounter >= 3) {
            triggerAnimation = true;
        }

        if (triggerAnimation) {
            const anim = animations[Math.floor(Math.random() * animations.length)];
            toast.custom((t) => (
                <div className={`${t.visible ? 'animate-enter' : 'animate-leave'}`}><SubmissionAnimation {...anim} /></div>
            ), { duration: 2000 });
            setSubmissionCounter(0);
        } else {
            setSubmissionCounter(submissionCounter + 1);
        }

        const dayDate = new Date(day + 'T00:00:00');
        const weekId = toYYYYMMDD(getStartOfWeek(dayDate));
        const docRef = doc(db, "workbooks", currentUser.uid, "weeks", weekId);

        const fieldToUpdate = `${module}Logs.${day}`;
        await setDoc(docRef, {
            [module === 'kickoff' ? 'kickoffLogs' : 'wrapLogs']: {
                [day]: {
                    ...dayLog,
                    submitted: true,
                    submittedAt: new Date().toISOString()
                }
            }
        }, { merge: true });
    };

    const navigateDate = (direction) => {
        const newDate = new Date(currentDate);
        const increment = viewMode === 'daily' ? 1 : 7;
        newDate.setDate(newDate.getDate() + (direction * increment));
        setCurrentDate(newDate);
    };

    const handleSaveExpectedHours = async () => {
        if (!selectedTeamMember) return;
        const userRef = doc(db, "users", selectedTeamMember);
        await setDoc(userRef, { expectedWeeklyHours: expectedHours }, { merge: true });
        setIsHoursDirty(false);
        alert('Expected hours set!');
    };

    const handleExport = () => {
        // This function would need significant changes to fetch all data for a range from Firestore.
        // For simplicity, it is left as a placeholder for now. A more robust solution would involve a backend function.
        alert("Export functionality requires a backend service to query date ranges across multiple documents efficiently.");
    };

    return (
        <div className="bg-gray-50 dark:bg-gray-900 min-h-screen font-sans">
            <Toaster />
            <style>{`
                .animation-container { position: fixed; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; overflow: hidden; }
                .confetti-fall-particle { position: absolute; width: 10px; height: 10px; background-color: var(--color); opacity: 0; animation: confetti-fall var(--duration) var(--delay) ease-out forwards; }
                @keyframes confetti-fall { 0% { transform: translate(var(--x), -10vh) rotate(0deg); opacity: 1; } 100% { transform: translate(var(--x), 110vh) rotate(720deg); opacity: 0; } }
                .confetti-burst-particle { position: absolute; top: 50%; left: 50%; width: 8px; height: 8px; background: var(--color); border-radius: 50%; opacity: 0; animation: confetti-burst 1.5s ease-out forwards; transform: rotate(calc(var(--i) * (360 / 50) * 1deg)) translateX(20px); }
                @keyframes confetti-burst { 0% { transform: rotate(calc(var(--i) * (360 / 50) * 1deg)) translateX(20px) scale(0.5); opacity: 1; } 100% { transform: rotate(calc(var(--i) * (360 / 50) * 1deg)) translateX(200px) scale(1.5); opacity: 0; } }
                .confetti-rain-particle { position: absolute; top: -20px; left: var(--x); width: 2px; height: 20px; background-color: var(--color); animation: confetti-rain 1s linear forwards; animation-delay: var(--delay); }
                @keyframes confetti-rain { 0% { transform: translateY(0); opacity: 1; } 100% { transform: translateY(110vh); opacity: 0; } }
                .confetti-launch-particle { position: absolute; bottom: 0; left: var(--x); width: 12px; height: 12px; background-color: var(--color); border-radius: 50%; animation: confetti-launch 1.5s ease-out forwards; animation-delay: var(--delay); }
                @keyframes confetti-launch { 0% { transform: translateY(0) scale(1); opacity: 1; } 50% { transform: translateY(-60vh) scale(0.5); opacity: 0.8; } 100% { transform: translateY(110vh) scale(0.2); opacity: 0; } }
            `}</style>
            <header className="bg-white dark:bg-gray-800 shadow-md">
                <nav className="container mx-auto px-6 py-3 flex justify-between items-center">
                    <h1 className="text-xl font-bold text-gray-800 dark:text-gray-200 cursor-pointer" onClick={() => isAdmin ? null : setCurrentModule(null)}>Tamira Workbook</h1>
                    {currentUser && (
                        <div className="flex items-center">
                            {!isAdmin && currentModule && <button onClick={() => handleModuleSelect(currentModule === 'kickoff' ? 'wrap' : 'kickoff')} className="mr-4 text-blue-600 dark:text-blue-400 hover:underline">Switch to {currentModule === 'kickoff' ? 'Daily - 5 minute Wrap' : 'Daily - 5 minute Kickoff'}</button>}
                            <span className="mr-4 text-gray-700 dark:text-gray-300">Welcome, <span className="font-bold">{currentUser.displayName}</span></span>
                            <button onClick={handleLogout} className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600">Logout</button>
                        </div>
                    )}
                </nav>
            </header>
            <main className="container mx-auto px-6 py-8">
                {!currentUser ? <LoginScreen theme={theme} setTheme={setTheme} handleLogin={handleLogin} handleMicrosoftLogin={handleMicrosoftLogin} /> :
                    (isAdmin ? (<div><AdminModuleHeader adminWeekStart={adminWeekStart} setAdminWeekStart={setAdminWeekStart} theme={theme} setTheme={setTheme} /><AdminView teamMembers={teamMembers} selectedTeamMember={selectedTeamMember} setSelectedTeamMember={setSelectedTeamMember} expectedHours={expectedHours} setExpectedHours={setExpectedHours} isHoursDirty={isHoursDirty} setIsHoursDirty={setIsHoursDirty} handleSaveExpectedHours={handleSaveExpectedHours} teamLogs={teamLogs} exportStartDate={exportStartDate} setExportStartDate={setExportStartDate} exportEndDate={exportEndDate} setExportEndDate={setExportEndDate} handleExport={handleExport} /></div>) :
                        (!currentModule ? <ModuleSelectionScreen handleModuleSelect={handleModuleSelect} /> : (<div><UserModuleHeader currentModule={currentModule} viewMode={viewMode} setViewMode={setViewMode} currentDate={currentDate} navigateDate={navigateDate} theme={theme} setTheme={setTheme} /><UserModuleView viewMode={viewMode} currentDate={currentDate} currentModule={currentModule} kickoffLogs={kickoffLogs} wrapLogs={wrapLogs} handleInputChange={handleInputChange} handleSubmit={handleSubmit} handleModuleSelect={handleModuleSelect} liveDate={liveDate} /></div>)))}
            </main>
        </div>
    );
};

export default App;
